module.exports = __webpack_public_path__ + "img/device_1017_1.b20ce1b4.svg";